import CategoryCard from '@/components/cards/category-card'
import Filter from '@/components/elements/filter'
import NotData from '@/components/elements/not-data'
import Search from '@/components/elements/search'
import SpinnerLoading from '@/components/elements/spinner'
import Toast from '@/components/elements/toast'
import ButtonMore from '@/components/layout/action/button-more'
import Layout from '@/components/layout/layout'
import ModalActionsDashboard from '@/components/modal/modal-actions-dashboard'
import { fetchCategories } from '@/services/api/categories/categories'
import { setCategoriesFn } from '@/store/features/categories'
import { sessionRefrestUpdate } from '@/store/features/state'
import { AppDispatch, RootState } from '@/store/store'
import CategoriesEntity from '@/entities/api/categories/categories'
import { Entities } from '@/entities/api/entities'
import JwtPayload from '@/entities/api/jwt'
import { filtersMapCategories } from '@/utils/maps/categories-maps'
import { Box, Flex, Grid, Heading, Separator } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const Categories = ({ data }: { data: JwtPayload }) => {
	const [modalAddOpen, setmodalAddOpen] = useState<Boolean>(false)
	const [modalEditOpen, setmodalEditOpen] = useState<Boolean>(false)
	const [isLoading, setIsloading] = useState<boolean>(false)
	const [search, setSearch] = useState<string>()
	const [categoriesFilter, setCategoriesFilter] = useState<
		CategoriesEntity[] | []
	>()
	const [category, setCategory] = useState<CategoriesEntity | {}>()
	const [filter, setFilter] = useState<Entities>(Entities.ALL)
	const token = useSelector((state: RootState) => state.auth.token)
	const categoryRefrest = useSelector(
		(state: RootState) => state.state.categoryRefrest
	)
	const categories = useSelector(
		(state: RootState) => state.categories.categories
	)
	const dispatch = useDispatch<AppDispatch>()

	useEffect(() => {
		const getCategories = async () => {
			try {
				setIsloading(true)
				if (categories.length === 0) {
					const response = await fetchCategories(token ?? '')
					if (response?.status === 401) {
						dispatch(sessionRefrestUpdate())
						return
					}
					dispatch(setCategoriesFn(response?.data ?? []))
					setCategoriesFilter(response?.data ?? [])
				} else {
					setCategoriesFilter(categories)
				}
				setIsloading(false)
			} catch (error) {
				Toast({ type: 'error', message: 'No se pudo obtener las categorias' })
				setIsloading(false)
			}
		}

		getCategories()
	}, [categoryRefrest])

	const openEditModal = async (category: CategoriesEntity) => {
		setCategory(category)
		setmodalEditOpen(true)
	}

	useEffect(() => {
		if (search && search.trim().length > 0) {
			const term = search.toLowerCase()
			setCategoriesFilter(
				categories?.filter(
					(cat) =>
						cat.name.toLowerCase().includes(term) ||
						cat.type.toLowerCase().includes(term)
				) ?? []
			)
			return
		}

		if (filter && filter !== Entities.ALL) {
			setCategoriesFilter(
				categories?.filter((cat) => cat.type === filter) ?? []
			)
			return
		}

		setCategoriesFilter(categories ?? [])
	}, [search, filter, categories])

	const filterOpen = (value: Entities) => {
		setFilter(value)
		setSearch('')
	}

	return (
		<Layout data={data}>
			{isLoading ? (
				<SpinnerLoading color='black' size='xl' />
			) : (
				<>
					<Flex
						w='full'
						p='4'
						alignItems='center'
						flexDirection={{ base: 'column', lg: 'row' }}
						justifyContent={{ base: 'start', lg: 'space-between' }}
					>
						<Heading
							as='h2'
							color='black'
							fontSize={{ base: '2xl', sm: '3xl' }}
							textAlign={{ base: 'center', sm: 'start' }}
							whiteSpace='normal'
							wordBreak='break-word'
							fontWeight='800'
						>
							Categorias
						</Heading>

						<Box
							w={{ base: 'full', xl: 'auto' }}
							flexDirection={{ base: 'column', sm: 'row' }}
							display='flex'
							alignItems='center'
							justifyContent={{ base: 'start', sm: 'center' }}
							p='4'
						>
							<ButtonMore click={() => setmodalAddOpen(true)} />
							<Box ml={{ base: '0', lg: '4' }}>
								<Search setSearch={setSearch} />
							</Box>
							<Box ml={{ base: '0', lg: '4' }}>
								<Filter label='Tipo :' filters={filtersMapCategories} setFilter={filterOpen} />
							</Box>
						</Box>
					</Flex>
					<Separator w='full' />
					<Box w='full' p='6'>
						{categoriesFilter && categoriesFilter.length > 0 ? (
							<Grid
								w='full'
								templateColumns={{
									base: '1fr',
									sm: 'repeat(2, 1fr)',
									lg: 'repeat(4, 1fr)',
									xl: 'repeat(6, 1fr)',
								}}
								gap='4'
							>
								{categoriesFilter.map((category, index) => (
									<CategoryCard
										key={index}
										token={token ?? ''}
										category={category}
										click={() => openEditModal(category)}
									/>
								))}
							</Grid>
						) : (
							<NotData />
						)}
					</Box>
					{modalAddOpen && (
						<ModalActionsDashboard
							open={modalAddOpen}
							action='add-category'
							close={() => setmodalAddOpen(false)}
						/>
					)}
					{modalEditOpen && (
						<ModalActionsDashboard
							open={modalEditOpen}
							action='edit-category'
							data={category}
							close={() => setmodalEditOpen(false)}
						/>
					)}
				</>
			)}
		</Layout>
	)
}

export default Categories
